import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=4c86f5c2&scoped=true"
import script from "./ResetPasswordForm.js?vue&type=script&lang=js&external"
export * from "./ResetPasswordForm.js?vue&type=script&lang=js&external"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=4c86f5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c86f5c2",
  null
  
)

export default component.exports